import React from 'react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import FloatingHelpButton from '../components/landing/FloatingHelpButton';
import ChatWidget from '../components/ChatWidget/ChatWidget';
import './LegalPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <Header />

      <div className="legal-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
      </div>

      <div className="legal-content">
        <div className="container">
          <section className="legal-section">
            <h2>Introduction</h2>
            <p>
              Welcome to eHaazri. We respect your privacy and are committed to protecting your personal data.
              This privacy policy will inform you about how we look after your personal data when you visit
              our website or use our services and tell you about your privacy rights and how the law protects you.
            </p>
          </section>

          <section className="legal-section">
            <h2>Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We may collect the following types of personal information:</p>
            <ul>
              <li>Identity Data: Name, username, job title</li>
              <li>Contact Data: Email address, phone number, business address</li>
              <li>Technical Data: IP address, browser type, device information</li>
              <li>Usage Data: Information about how you use our website and services</li>
              <li>Biometric Data: Facial recognition data for attendance verification (with explicit consent)</li>
              <li>Location Data: GPS coordinates when marking attendance (with permission)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>We use your personal data for the following purposes:</p>
            <ul>
              <li>To provide and maintain our attendance management services</li>
              <li>To verify attendance and prevent fraud through facial recognition</li>
              <li>To track attendance locations through geofencing</li>
              <li>To send you administrative information and updates</li>
              <li>To improve our services and develop new features</li>
              <li>To comply with legal obligations</li>
              <li>To protect against fraud and unauthorized access</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Legal Basis for Processing</h2>
            <p>We process your personal data based on:</p>
            <ul>
              <li><strong>Consent:</strong> You have given explicit consent for biometric data processing</li>
              <li><strong>Contract:</strong> Processing is necessary to fulfill our service agreement</li>
              <li><strong>Legal Obligation:</strong> Processing is required by law</li>
              <li><strong>Legitimate Interests:</strong> Processing is necessary for our legitimate business interests</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal data:
            </p>
            <ul>
              <li>End-to-end encryption for sensitive data transmission</li>
              <li>Secure cloud storage with regular backups</li>
              <li>Access controls and authentication mechanisms</li>
              <li>Regular security audits and vulnerability assessments</li>
              <li>Employee training on data protection practices</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Data Retention</h2>
            <p>
              We retain your personal data only for as long as necessary to fulfill the purposes outlined
              in this privacy policy, unless a longer retention period is required by law. Biometric data
              is retained only during your active employment and deleted upon account termination.
            </p>
          </section>

          <section className="legal-section">
            <h2>Your Rights</h2>
            <p>Under data protection laws, you have the following rights:</p>
            <ul>
              <li><strong>Right to Access:</strong> Request copies of your personal data</li>
              <li><strong>Right to Rectification:</strong> Request correction of inaccurate data</li>
              <li><strong>Right to Erasure:</strong> Request deletion of your personal data</li>
              <li><strong>Right to Restrict Processing:</strong> Request limitation of data processing</li>
              <li><strong>Right to Data Portability:</strong> Receive your data in a portable format</li>
              <li><strong>Right to Object:</strong> Object to processing of your personal data</li>
              <li><strong>Right to Withdraw Consent:</strong> Withdraw consent for biometric data processing</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Third-Party Services</h2>
            <p>
              We may share your data with trusted third-party service providers who assist us in operating
              our platform, such as cloud hosting providers and payment processors. These parties are
              contractually obligated to protect your data and use it only for specified purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>International Data Transfers</h2>
            <p>
              Your data may be transferred to and processed in countries outside your country of residence.
              We ensure appropriate safeguards are in place to protect your data in accordance with applicable
              data protection laws.
            </p>
          </section>

          <section className="legal-section">
            <h2>Cookies and Tracking</h2>
            <p>
              We use cookies and similar tracking technologies to enhance your experience on our website.
              You can control cookie preferences through your browser settings. Essential cookies are
              necessary for the website to function properly.
            </p>
          </section>

          <section className="legal-section">
            <h2>Children's Privacy</h2>
            <p>
              Our services are not intended for individuals under the age of 18. We do not knowingly
              collect personal data from children. If you become aware that a child has provided us with
              personal data, please contact us immediately.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any significant
              changes by posting the new policy on this page and updating the "Last updated" date.
              We encourage you to review this policy periodically.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this privacy policy or our data practices, please contact us:
            </p>
            <ul>
              <li>Email: privacy@ehaazri.com</li>
              <li>Website: Use our Contact Support form</li>
            </ul>
          </section>
        </div>
      </div>

      <Footer />
      <FloatingHelpButton />
      <ChatWidget />
    </div>
  );
};

export default PrivacyPolicy;
